/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdatePreviousStayRequest
 */
export interface UpdatePreviousStayRequest {
    /**
     * 
     */
    has_previous_stay_in_facility: boolean;
    /**
     * 
     */
    comment?: string;
}

/**
 * Check if a given object implements the UpdatePreviousStayRequest interface.
 */
export function instanceOfUpdatePreviousStayRequest(value: object): value is UpdatePreviousStayRequest {
    if (!('has_previous_stay_in_facility' in value) || value['has_previous_stay_in_facility'] === undefined) return false;
    return true;
}

export function UpdatePreviousStayRequestFromJSON(json: any): UpdatePreviousStayRequest {
    return UpdatePreviousStayRequestFromJSONTyped(json, false);
}

export function UpdatePreviousStayRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdatePreviousStayRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'has_previous_stay_in_facility': json['has_previous_stay_in_facility'],
        'comment': json['comment'] == null ? undefined : json['comment'],
    };
}

export function UpdatePreviousStayRequestToJSON(json: any): UpdatePreviousStayRequest {
    return UpdatePreviousStayRequestToJSONTyped(json, false);
}

export function UpdatePreviousStayRequestToJSONTyped(value?: UpdatePreviousStayRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'has_previous_stay_in_facility': value['has_previous_stay_in_facility'],
        'comment': value['comment'],
    };
}

